// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".begintask[data-v-de5dc514] {\n  color: #0CA51A;\n}\n.endtask[data-v-de5dc514] {\n  color: #FF0000;\n}\n", ""]);
// Exports
module.exports = exports;
